import { gql } from '@apollo/client';

const user = ` 
    _id
    email
    firstName
    lastName
    status
    emailVerified
    mobile
    organizationId
    roles{
      roleId
      name
      organizationId
      brandId
      storeId
      countries
      permissions{
        permissionId
        name
        action
        subject
        conditions
      }
      extraPermissions{
        permissionId
        name
        action
        subject
        conditions
      }
      deniedPermissions{
        permissionId
        name
        action
        subject
        conditions
      }
    }
    dashboardSettings{
        organizationId
        brandId
        storeId
        countryCode
    }
    createdAt
    updatedAt
`;

/**
 * USER LOGIN
 */
export const USER_LOGIN = gql`
  mutation USER_LOGIN($input: LoginUserInput!) {
    login(input: $input) {
      token
      user {
         ${user}
      }
    }
  }
`;

/**
 * USER PROFILE
 */
export const USER_PROFILE = gql`
  query USER_PROFILE {
    profile{ 
      ${user} 
    }
  }
`;

export const CREATE_OR_UPDATE_USER = gql`
  mutation CREATE_OR_UPDATE_USER($input: CreateUserInput!) {
    createOrUpdateUser(input: $input) {
      ${user}
    }
  }
`;

export const GET_USERS = gql`
  query GET_USERS($input: UsersInput!){
    users(input: $input) {
      totalPages
      totalUsers
      currentOffset
      users {
        ${user}
      }
    }
  }
`;

export const UPDATE_DASHBOARD_SETTINGS = gql`
  mutation UPDATE_DASHBOARD_SETTINGS($input: DashboardSettingsInput!) {
    updateDashboardSettings(input: $input) {
      ${user}
    }
  }
`;
